import React, { useEffect, useState } from 'react';

const Loader = ({ onLoadComplete }) => {
    const [isComplete, setIsComplete] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsComplete(true);
            setTimeout(() => onLoadComplete(), 800);
        }, 2500); // Increased slightly to let animation finish

        return () => clearTimeout(timer);
    }, [onLoadComplete]);

    return (
        <div className={`fixed inset-0 z-[100] bg-dark-900 flex flex-col items-center justify-center transition-opacity duration-1000 ${isComplete ? 'opacity-0 pointer-events-none' : 'opacity-100'}`}>

            <div className="text-center">
                {/* Main Brand Name - Appears First */}
                <h1
                    className="font-display font-black text-4xl md:text-6xl text-white tracking-wider mb-4 drop-shadow-2xl opacity-0"
                    style={{ animation: 'appearUp 1s ease-out forwards 0.2s' }}
                >
                    MD SAMSUDDIN
                </h1>

                {/* Subtitle - Appears Second */}
                <div
                    className="flex items-center justify-center space-x-4 opacity-0"
                    style={{ animation: 'appearUp 1s ease-out forwards 0.8s' }}
                >
                    <div className="h-[1px] w-8 md:w-16 bg-royal-500/50"></div>
                    <p className="font-sans text-royal-500 text-[10px] md:text-sm font-bold tracking-[0.2em] uppercase whitespace-nowrap">
                        SHUTTER & ENGINEERING WORKS
                    </p>
                    <div className="h-[1px] w-8 md:w-16 bg-royal-500/50"></div>
                </div>
            </div>

            {/* Custom Keyframe for the "Appearing" Effect */}
            <style jsx>{`
                @keyframes appearUp {
                    0% {
                        opacity: 0;
                        transform: translateY(20px);
                        filter: blur(10px);
                    }
                    100% {
                        opacity: 1;
                        transform: translateY(0);
                        filter: blur(0);
                    }
                }
            `}</style>
        </div>
    );
};

export default Loader;
